<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
 <div class="card m-2 m-lg-3">
        <div class="card-body">
          <div class="row m-4 align-items-center">
            <div class="col mt-4 d-none d-sm-block">
              <h4>Student payment details</h4>
            </div>
             <div class="col mt-4  d-block d-sm-none">
              <h4>Details</h4>
            </div>
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end add-btn">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary rental-heading new-btn d-none d-sm-block"
                @click="BackToServices"
              >
                Back To Education Fee Payments
              </llp-button>
                <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary rental-heading new-btn d-block d-sm-none "
                @click="BackToServices"
              >
                Go Back
              </llp-button>
            </div>
          </div>
          <div class="m-4">
            <div v-if="loading" class="bill-loader-container">
              <div class="spinner"></div>
            </div>
            <div v-if="isBillViewed && billDetails" class="row">
              <div class="col-lg-6">
                <div class="card">
                  <div class="m-4">
                    <div class="row">
                      <div class="col-lg-4">
                        <strong> Student Name :</strong>
                      </div>
                      <div class="col-lg-6">{{ billDetails.customerName }}</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <strong> Amount :</strong>
                      </div>
                      <div class="col-lg-4 bill-details">
                        {{ billDetails.billAmount }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <strong>last Date : </strong>
                      </div>
                      <div class="col-lg-6">{{ billDetails.dueDate }}</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-4">
                        <strong>Student Roll Number : </strong>
                      </div>
                      <div class="col-lg-6">{{ billDetails.billNumber }}</div>
                    </div>
                   

                    <div class="col-lg-4">
                      <llp-button
                        :loadSpinner="payloadSpinner"
                        classNames="btn-secondary new-btn"
                        @click="ProceedToPayment()"
                      >
                        Proceed to payment
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
     
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
// import axios from "axios";
export default {
  setup() {},
  data() {
    return {
      studentUniqueID: this.$route.params.uniqueId,
      billDetails: "",
      isBillViewed: false,
      loading: false,
      payloadSpinner: false,
    };
  },
  mounted() {
    this.fetchingBillDetails();
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    document.head.appendChild(script);
  },
  methods: {
    BackToServices() {
       this.$router.back();
    },
    async fetchingBillDetails() {
      this.loading = true;
     
      try {
      this.billDetails = {
      customerName: "Ram",
      billAmount: 1000,
      dueDate: "28-03-2025",
      billNumber: "S12345",
      
    };

        this.loading = false;
      } catch (error) {
        this.payloadSpinner = false;
        this.$refs.toast.show("No bill.", "error");
      } finally {
        this.isBillViewed = true;
        this.loading = false;
      }
    },
    async ProceedToPayment() {
      this.payloadSpinner = true;
      const details = {
        ...this.billDetails,
        user_id: 52,
        pay_amount: this.billDetails.billAmount,
      };

      try {
        const paymentResponse = await NetworkService.post(
          "get-payment-link",
          details
        );
        const responseData = paymentResponse.data.data;
        if (responseData.order_status && window.Cashfree) {
          const cashfree = window.Cashfree({
            mode: "sandbox",
          });
          const checkoutOptions = {
            paymentSessionId: responseData.payment_session_id,
            redirectTarget: "_modal",
          };
          try {
            const result = await cashfree.checkout(checkoutOptions);
            this.payloadSpinner = false;
            const message = result.paymentDetails.paymentMessage;
            this.$refs.toast.show(message);
            if (result.paymentDetails.paymentMessage.includes("finished")) {
              setTimeout(() => {
                this.$router.push("/thank-you");
              }, 3000);
            }
          } catch (error) {
            this.payloadSpinner = false;
            this.$refs.toast.show(
              "An error occurred during payment. Please try again.",
              "error"
            );
            setTimeout(() => {
              this.$router.back();
            }, 3000);
          }
        }
      } catch (error) {
        this.payloadSpinner = false;
        this.$refs.toast.show(
          "An error occurred during payment. Please try again.",
          "error"
        );
        setTimeout(() => {
          this.$router.push("/services");
        }, 3000);
      }
    },
  },
};
</script>
